import { makeObservable, computed, observable, action } from 'mobx';

import { Store } from '../../store/store';
import { StoreNode } from '../../store';

import { CommentState } from './commentState';
import { Comment } from '../../entities/comment';
import { PlayerCommentsState } from './playerCommentsState';

export type CommentThreadProps = {
  playerComments?: PlayerCommentsState,
  threadComments: Comment[]
};

export class CommentThreadState
  extends StoreNode {

  constructor(store: Store, props: CommentThreadProps) {
    super(store, props);
    makeObservable(this, {
      playerComments: computed,
      threadComments: computed,
      comments: computed,
      comment: computed,
      commentModel: computed,
      replies: computed,
      isActive: observable,
      hasReplyInput: observable,
      showPrevReplies: observable,
      toggleShowPrevReplies: action,
      setIsActive: action,
      setHasReplyInput: action,
      handlePointerEnter: action,
      handlePointerLeave: action,
    });
  }

  get playerComments(): PlayerCommentsState {
    return this.resolvedProps.playerComments ?? null;
  }

  get threadComments(): Comment[] {
    return this.resolvedProps.threadComments ?? [];
  }

  get comments(): CommentState[] {
    return this.threadComments.map(comment => (
      new CommentState(this.store, { comment, thread: this })
    ));
  }

  get comment(): CommentState {
    return this.comments.filter(comment => !comment.isReply)[0];
  }

  get commentModel(): Comment {
    return this.comment?.comment;
  }

  get replies(): CommentState[] {
    return this.comments.filter(comment => comment.isReply);
  }

  isActive: boolean = false;

  hasReplyInput: boolean = false;

  showPrevReplies: boolean = false;

  toggleShowPrevReplies() {
    this.showPrevReplies = !this.showPrevReplies;
  }

  setIsActive(isActive: boolean) {
    if (this.hasReplyInput) return;
    this.isActive = isActive;
  }

  setHasReplyInput(hasReplyInput: boolean) {
    this.hasReplyInput = hasReplyInput;
  }

  handlePointerEnter(_evt: PointerEvent) {
    this.setIsActive(true);
  }

  handlePointerLeave(_evt: PointerEvent) {
    this.setIsActive(false);
  }
}